import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../assets/styles/projects.css";
import ContentHeading from "../components/ContentHeading";
// import ContentTitle from "../components/ContentTitle";
import { ourProject } from "../data";
import icon from "../assets/images/svg/service-icon.svg";
// import OurTeam from "../components/OurTeam";
// import Testimonials from "../components/Testimonials";
import Consultation from "../components/Consultation";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Projects = () => {
  return (
    <div>
      <Helmet>
        <title>
          Our Projects | Architecture & Interior Work by ASK & Associates
        </title>
        <meta
          name="description"
          content="Explore residential and commercial architecture, interior design and construction projects completed by ASK & Associates."
        />
        <link rel="canonical" href="https://askandassociates.com/projects" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "Architecture & Interior Projects",
            url: "https://askandassociates.com/projects",
            description:
              "A portfolio of residential and commercial architecture and interior design projects by ASK & Associates.",
            isPartOf: {
              "@type": "WebSite",
              name: "ASK & Associates",
              url: "https://askandassociates.com",
            },
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CreativeWork",
            name: "Architecture & Interior Design Projects",
            creator: {
              "@type": "Organization",
              name: "ASK & Associates",
            },
          })}
        </script>
      </Helmet>
      <section className="section">
        <Container>
          <div className="mb-5">
            <ContentHeading heading={"Projects"} />
            <h1 className="display-6 text-eerie-black fw-600 mb-4">
              Our Architecture & Interior Design Projects
            </h1>
          </div>
          <Row>
            {ourProject.map((project) => (
              <Col key={project.id} sm={12} md={6} className="mb-4">
                <article className="project-section cursor-pointer border-silver-chalice border-top-0 border-start-0 border-end-0 h-100">
                  <div className="overflow-hidden d-flex flex-column project-image ">
                    <img
                      className=" img-fluid"
                      src={project.image}
                      alt={`${project.title} architecture project by ASK & Associates`}
                      loading="lazy"
                    />
                  </div>
                  <Link
                    to="/projects"
                    className="bg-cultured text-deep-moss-green fw-500 fs-14 rounded-1 p-2 mt-4 d-inline-block"
                  >
                    {project.linktext}
                  </Link>
                  <div className="d-flex justify-content-between align-items-center mt-2 mb-4">
                    <h3 className="h4 m-0 text-phthalo-green fw-600">
                      {project.title}
                    </h3>
                    <img
                      src={icon}
                      alt="Project details arrow icon"
                      width="24px"
                    />
                  </div>
                </article>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      {/* <OurTeam />
      <Testimonials /> */}
      <Consultation />
    </div>
  );
};

export default Projects;
